import '../css/Winner.css'
import {useLocation, useNavigate} from "react-router-dom";
import Header from "./Header";
import {barPrizes, homePrizes} from "../constants/Constants";
import {useEffect, useState} from "react";
import arrayShuffle from "array-shuffle";
import hamburgerIcon from "../icons/hamburger-pineapplespin.png";
import Footer from "./Footer";

const bounce = 'bounce 1s linear infinite';

function Winner() {
    const {state} = useLocation();
    const [prizes] = useState(getPrizes());
    const navigate = useNavigate();

    const [hamburgerDisplay, setHamburgerDisplay] = useState("0");
    const [hamburgerRightBorder, setHamburgerRightBorder] = useState("none");
    const [hamburgerBottomBorder, setHamburgerBottomBorder] = useState("none");

    function navClick(_selection) {
        handleHamburgerCancel();
        switch (_selection) {
            case "new":
                localStorage.removeItem('nachoSpinState');
                navigate("/");
                break;
            default:
        }
    }

    function handleHamburgerDisplay() {
        if (hamburgerDisplay === "0") {
            setHamburgerDisplay("50%");
            setHamburgerRightBorder("solid 3px black");
            setHamburgerBottomBorder("solid 3px black");
        } else {
            handleHamburgerCancel();
        }
    }

    function handleHamburgerCancel() {
        setHamburgerDisplay("0");
        setHamburgerRightBorder("none");
        setHamburgerBottomBorder("none");
    }

    function getWinner() {
        if (state != null) {
            return state.winner;
        } else {
            return {
                name: 'Player 1'
            }
        }
    }

    function getEdition() {
        if (state != null) {
            return state.edition;
        } else {
            return 'bar';
        }
    }

    useEffect(() => {
        if (state == null) {
            navigate("/");
        }
    }, []);

    function getPrizes() {
        let p = getEdition() === 'bar' ? barPrizes : homePrizes;
        p = arrayShuffle(p);
        let newPrizes = [];
        for (let i = 0; i < 5; i++) {
            newPrizes.push(p.pop());
        }
        return newPrizes;
    }

    const prizesList = (
        <ul className={"prizes-list"}>
            {[...prizes].map(prize => (
                <li key={prize} className={"prize"}>{prize}</li>
            ))}
        </ul>
    )

    function goToNewGame() {
        localStorage.removeItem('nachoSpinState');
        navigate("/");
    }

    const hamburger = (
        <button onClick={() => handleHamburgerDisplay()} className={"hamburger-button"}><img
            className={"hamburger-icon"} src={hamburgerIcon} alt={"hamburgerIcon"}/></button>
    )

    const navMenu = (
        <div className={"hamburger-menu"}
             style={{width: hamburgerDisplay, borderRight: hamburgerRightBorder, borderBottom: hamburgerBottomBorder}}>
            <button type={"button"} className={"hamburger-cancel"} onClick={() => handleHamburgerCancel()}>x</button>
            <div className={"nav-button-container"}>
                <button className={"nav-button"} onClick={() => navClick("new")}>New Game
                </button>
            </div>
        </div>
    )

    const [fade, setFade] = useState(false);
    useEffect(() => {
        setFade(true);
        setTimeout(() => {
            setFade(false);
        }, 10);
    }, []);

    return (
        <div className={"winner"}>
            <Header hamburger={hamburger}/>
            {navMenu}
            <div className={`winner-body ${fade ? 'fade-out' : 'fade-in'}`}
                 onClick={() => handleHamburgerCancel()}>
                <h1 className={"winner-heading"}>
                    {getWinner().name} wins!
                </h1>
                <div className={"congratulations"}><div>Congratulations, {getWinner().name}!</div><div>The nacho has been spun.</div><div>You may
                    now collect your prize.</div>
                </div>
                {/*<div className={"congratulations"}> Congratulations, {getWinner().name}! Your quest is complete. You may*/}
                {/*    choose any 2 of the following prizes.*/}
                {/*</div>*/}
                {/*<div className={"prizes-list-container"}>{prizesList}</div>*/}
                <div className={"winner-new-game-button-container"}>
                    <button type={"button"} className={"winner-new-game-button"} style={{animation: bounce}}
                            onClick={() => goToNewGame()}>New Game
                    </button>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default Winner;